import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { Switch, FormControlLabel } from '@material-ui/core';
import { fetchOptions } from '../queries';
import FormInput from '../input/FormInput';

const LTNumber = ({ name, query, props, enableEdit }) => {
    const [inputProps, setInputProps] = useState({ ...props, disabled: true });
    const [originalValue, setOriginalValue] = useState();
    const [editable, setEditable] = useState(false);
    const { getValues, setValue } = useFormContext();

    const fetchAndSetValue = async (setOriginal) => {
        const { endpoint, useLoopback, where, labelKey } = query;
        const fetchedValue = await fetchOptions({ endpoint, useLoopback, where });
        setValue(name, fetchedValue[labelKey]);
        if (setOriginal) {
            setOriginalValue(fetchedValue[labelKey]);
        }
    };

    useEffect(() => {
        const [value] = getValues([name]);
        if (!value) {
            fetchAndSetValue(true);
        } else {
            setOriginalValue(value);
        }
    }, []);

    const onChange = (_e, val) => {
        setEditable((prev) => !prev);
        setInputProps((prev) => ({ ...prev, disabled: !Boolean(val) }));
        if (originalValue) {
            setValue(name, originalValue);
        }
    };

    return (
        <>
            {enableEdit && (
                <FormControlLabel
                    control={<Switch checked={editable} onChange={onChange} />}
                    label={`Handwritten ${inputProps.label}`}
                    labelPlacement="right"
                    // wrap
                />
            )}
            <FormInput name={name} props={inputProps} />
        </>
    );
};

export default LTNumber;
